import { useEffect } from 'react';
import styles from '../styles/components/overview.module.css';


interface ComponentProps {
    children: React.ReactNode;
    cancel: () => void;
    zIndex?: number;
};


export default function Overview({children, cancel, zIndex = 51}: ComponentProps) {
    const tg = window.Telegram.WebApp;

    useEffect(() => {
        tg.BackButton.show();
        tg.BackButton.onClick(cancel);

        return () => {
            tg.BackButton.offClick(cancel);
            tg.BackButton.hide();
        };
    }, []);

    return <div className={styles.body} style={{zIndex: zIndex}}>
        {children}
    </div>;
};